import { useParams } from "react-router";

import { ActivityByDatabaseV2 } from "../shared";

export const DatabaseActivityPage = () => {
  const { id = "" } = useParams();
  return <ActivityByDatabaseV2 dbId={id} />;
};
